<template>
    <div class="coursemore">
        <tab></tab>
       
        <div class="sort">
            <!-- <div class="select" style="width:200px;float:left;margin-left:28px;">
                <Select v-model="value" style="width:144px" placeholder="请选择">
                    <Option v-for="(item,index) in picUrl" :value="item" :key="index">{{ item }}</Option>
                </Select>
            </div> -->


            <div style="float:left;font-size:15px;">当前位置：首页>视频课堂>更多课程列表</div>

            <div class="search">
                <input type="text" placeholder="请输入关键字" ref="searchValue">
                <img src="../../static/videoclass/search.png" alt="" @click="searchFn()">
            </div>
        </div>
        <div class="courselist">
            <div class="category-l-i" v-for="(item, index) in courseList" :key='index'>
                <img :src="item.coverUrl" alt="" @click="toVideoList(item.id)">

                <div style="width:100%;height:15px;line-height:15px;fonr-size:15px;text-align:center;margin-top:8px;">{{item.name}}</div>
                <div style="width:100%;height:15px;line-height:15px;fonr-size:15px;text-align:center;margin-top:4px;">23门课程</div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import tab from '../common/tab.vue'

    export default {
        name: "coursemore",
        components:{
            tab,
        },
        data () {
            return {
                picUrl:["1","2","3","4","5","6","7","8","9","10"],
                courseList:[],
                value:'',
                catalogueId:0,
            };
        },
        methods: {
            searchFn(){
                // course/selectCourseByCourseNameMore
                // get
                // courseName
                // catalogueId
                
                let searchValue = this.$refs.searchValue.value;
                this.$axios.get("/v1/muke/student/course/selectCourseByCourseNameMore?courseName=" + searchValue+"&catalogueId=" + this.catalogueId)
                .then(({data})=>{
                    if(data.code == 200){
                        this.courseList = data.data;
                    }
                })

            },
            toVideoList(id){
                this.$router.push({
                    path: '/videolist',
                    query: {
                        courseId:id,
                    
                    }
                })
            }
        },
        created(){
            let catalogueId = this.$route.query.courseId;
            this.catalogueId = catalogueId;
            this.$axios.post("/v1/muke/student/course/selectCourseMore",{
                catalogueId,
            }).then(({data})=>{
                if(data.code == 200){
                    this.courseList = data.data;
                }
            })
        },
        mounted(){

        }
    }
</script>

<style scoped lang="less">
    .coursemore{
        width:100%;
        background:#f7f7f7;
        .sort{
            width:1200px;
            height:66px;
            line-height: 66px;
            margin:0 auto;
            background:white;
            margin-top:20px;
            .search{
                float:right;width:316px;height:36px;
                border:1px solid #d2d2d2;
                margin-top:15px;margin-right:19px;
                img{
                    display: block;width:24px;height:19px;
                    float:right;margin-top:7px;margin-right:12px;
                }
                input{
                    height:36px;
                    float:left;
                    width:254px;
                    margin-left:10px;
                }
            }
        }
        .courselist{
            width:1200px;
            margin:0 auto;
            margin-top:60px;
            height:auto;
            overflow: hidden;
            .category-l-i{
                float:left;width:228px;height:230px;
                background:#fff;margin-left:10px;margin-bottom:50px;
                img{
                    display:block;width:100%;height:177px;
                }
            }
            // .category-l-i:nth-of-type(1){
            //     margin-left:12px;
            // }
        }
    
    }
</style>
